export const workshopLibrary = [
  // TEAM DEVELOPMENT
  {
    id: 1,
    title: "Team-refleksjon",
    category: "Teamutvikling",
    icon: "Eye",
    description: "Stoppe opp og vurdere egen praksis for kontinuerlig læring og forbedring."
  },
  {
    id: 2,
    title: "Kommunikasjonsverksted",
    category: "Teamutvikling",
    icon: "MessageSquare",
    description: "Forbedre informasjonsflyt, klarhet og relasjoner gjennom praktiske øvelser."
  },
  {
    id: 3,
    title: "Tillitsbygging",
    category: "Teamutvikling",
    icon: "Heart",
    description: "Hvordan bygge og vedlikeholde tillit som grunnmur i et velfungerende team."
  },
  {
    id: 4,
    title: "Feedback-kultur",
    category: "Teamutvikling",
    icon: "Repeat",
    description: "Etablere sunne og trygge rutiner for konstruktiv tilbakemelding i hverdagen."
  },

  // PSYCHOLOGICAL SAFETY
  {
    id: 5,
    title: "Introduksjon til psykologisk trygghet",
    category: "Psykologisk Trygghet",
    icon: "Shield",
    description: "Grunnleggende forståelse av hvorfor trygghet er avgjørende for prestasjon."
  },
  {
    id: 6,
    title: "Ytringskultur (Speaking up)",
    category: "Psykologisk Trygghet",
    icon: "Zap",
    description: "Trening i å si ifra, stille kritiske spørsmål og dele ideer uten frykt."
  },
  {
    id: 7,
    title: "Læring av feil",
    category: "Psykologisk Trygghet",
    icon: "RefreshCw",
    description: "Hvordan snu uhell og feiltrinn til verdifull organisasjonslæring."
  },
  {
    id: 8,
    title: "Trygge diskusjoner",
    category: "Psykologisk Trygghet",
    icon: "Shield",
    description: "Metodikk for å håndtere uenighet på en saklig og ivaretakende måte."
  },

  // CONFLICT MANAGEMENT
  {
    id: 9,
    title: "Forståelse av konflikter",
    category: "Konflikthåndtering",
    icon: "AlertCircle",
    description: "Lær å gjenkjenne konfliktmønstre og eskaleringstrinn i en tidlig fase."
  },
  {
    id: 10,
    title: "Konfliktkartlegging",
    category: "Konflikthåndtering",
    icon: "Map",
    description: "Verktøy for å analysere underliggende årsaker og behov i en fastlåst situasjon."
  },
  {
    id: 11,
    title: "Den vanskelige samtalen",
    category: "Konflikthåndtering",
    icon: "MessageCircle",
    description: "Praktisk trening på samtalekunst i krevende mellommenneskelige situasjoner."
  },
  {
    id: 12,
    title: "Strategier for konfliktløsning",
    category: "Konflikthåndtering",
    icon: "Target",
    description: "Gjennomgang av ulike metoder for mekling og fasilitert dialog."
  },

  // WORKLOAD MANAGEMENT
  {
    id: 13,
    title: "Stressmestring i hverdagen",
    category: "Arbeidsbelastning",
    icon: "Wind",
    description: "Verktøy for å gjenkjenne og håndtere stress før det blir helseskadelig."
  },
  {
    id: 14,
    title: "Prioritering av arbeidsoppgaver",
    category: "Arbeidsbelastning",
    icon: "Layers",
    description: "Metoder for å håndtere stor arbeidsmengde og tidspress effektivt."
  },
  {
    id: 15,
    title: "Energiledelse",
    category: "Arbeidsbelastning",
    icon: "Battery",
    description: "Fokus på restitusjon, pauser og hvordan opprettholde energi over tid."
  },
  {
    id: 16,
    title: "Sunne arbeidsrutiner",
    category: "Arbeidsbelastning",
    icon: "Sun",
    description: "Etablering av felles normer for tilgjengelighet, møter og arbeidsflyt."
  },

  // LEADERSHIP
  {
    id: 17,
    title: "Lederkommunikasjon",
    category: "Ledelse",
    icon: "Mic",
    description: "Tydelig forventningsavklaring og involverende kommunikasjon."
  },
  {
    id: 18,
    title: "Håndtering av krevende adferd",
    category: "Ledelse",
    icon: "UserX",
    description: "Lederens verktøy for å følge opp ansatte som utfordrer arbeidsmiljøet."
  },
  {
    id: 19,
    title: "Støtte til ansattes trivsel",
    category: "Ledelse",
    icon: "Coffee",
    description: "Hvordan utøve omsorg og støtte i en travel og resultatorientert hverdag."
  },
  {
    id: 20,
    title: "Ledelse i endring",
    category: "Ledelse",
    icon: "TrendingUp",
    description: "Navigere teamet trygt gjennom organisatoriske endringer og usikkerhet."
  },

  // ORGANIZATIONAL CULTURE
  {
    id: 21,
    title: "Verdiverksted",
    category: "Organisasjonskultur",
    icon: "Star",
    description: "Forankre teamets adferd og beslutninger i felles, meningsfulle verdier."
  },
  {
    id: 22,
    title: "Kulturkartlegging",
    category: "Organisasjonskultur",
    icon: "Globe",
    description: "Identifisere de uformelle normene som styrer hvordan vi jobber sammen."
  },
  {
    id: 23,
    title: "Forventninger til adferd",
    category: "Organisasjonskultur",
    icon: "CheckSquare",
    description: "Tydeliggjøring av hva som er akseptabel og ønsket oppførsel på arbeidsplassen."
  },
  {
    id: 24,
    title: "En respektfull arbeidsplass",
    category: "Organisasjonskultur",
    icon: "Smile",
    description: "Forebygging av trakassering og bygging av en inkluderende kultur."
  },

  // WORK ENVIRONMENT
  {
    id: 25,
    title: "Risikoanalyse av arbeidsmiljø",
    category: "Arbeidsmiljø",
    icon: "AlertTriangle",
    description: "Identifisere og vurdere fysiske og psykososiale risikofaktorer."
  },
  {
    id: 26,
    title: "Trivselssjekk for teamet",
    category: "Arbeidsmiljø",
    icon: "Activity",
    description: "En lavterskel gjennomgang av status for samarbeid og motivasjon."
  },
  {
    id: 27,
    title: "Verksted for tiltaksplan",
    category: "Arbeidsmiljø",
    icon: "Edit3",
    description: "Snu analyse-resultater til konkrete, målbare handlingsmål."
  }
];